// DEPENDENCIES
import React, { Component } from 'react';
import Slider from 'react-rangeslider-extended';

// INNER IMPORTS
import './MoneySlider.css';

class MoneySlider extends Component {
    constructor (props) {
        super(props);
        this.state = {};
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.datatypes && this.state.value === undefined) {
            this.setState({
                value: nextProps.datatypes.defaults.initialPrice
            })
        }
    }

    handleChange (value) {
        this.setState({ value })
    }

    render () {
        const { value } = this.state;
        return (
            <div className='vertical-slider'>
                <Slider
                    min={0}
                    max={this.props.datatypes ? this.props.datatypes.defaults.maxPrice : 200}
                    value={value}
                    orientation='vertical'
                    onChange={(val) => this.handleChange(val)}
                    onChangeComplete={() => this.props.onChange('price', value)}
                />
            </div>
        )
    }
}

export default MoneySlider;


// WEBPACK FOOTER //
// ./src/Components/Main/MoneySlider.js